import i18n from 'lib/i18n'

export const translate = i18n('contracts')



// WEBPACK FOOTER //
// ./components/easinsure/contracts/translate.js